module.exports = __webpack_public_path__ + "static/media/logo_argentina_presidencia.c0a47cb0.svg";